import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';

import './disclosureTrigger.styles.scss';

import imgAdd from 'images/content-more-thin-24-blue.svg';
import imgRemove from 'images/content-less-thin-24-blue.svg';

export default class DisclosureTrigger extends Component {
    constructor(props) {
        super(props);
        this.state = {
            disclosed: props.disclosed || false,
        };
    }

    onClick() {
        const { onTrigger } = this.props;
        const newDisclosureState = !this.state.disclosed;

        this.setState({
            disclosed: newDisclosureState,
        });
        onTrigger(newDisclosureState);
    }

    static getDerivedStateFromProps(props) {
        return props;
    }

    render() {
        const { text, ...other } = this.props;

        // remove useless attributes before passing on to Button
        delete other.onTrigger;
        delete other.disclosed;

        return (
            <div className="disclosure-trigger">
                <Button
                    onClick={this.onClick.bind(this)}
                    text={text}
                    icon={this.state.disclosed ? imgRemove : imgAdd}
                    theme="link"
                    aria-expanded={this.state.disclosed}
                    {...other}
                />
            </div>
        );
    }
}

DisclosureTrigger.propTypes = {
    text: PropTypes.string.isRequired,
    onTrigger: PropTypes.func.isRequired,
    disclosed: PropTypes.bool,
};
